import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';

import { SliceTabsSettings } from './settings/slice-tabs-settings.model';


export const SliceTabsDefinition: IdtComponentDefinition = {
  id: 'slice-tabs',
  role: IdtComponentRole.Slice,
  numSlots: 1,
  defaultSlot: 1
};

export const SliceTabsCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Pestañas',
  group: CmsComponentGroups.Components,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): SliceTabsSettings => ({
    general: {
      numSlots: 1,
      tabs: [
        { alt: 'Pestaña 1' }
      ],
      tabType: 'text',
      tabPosition: 'top-left',
      defaultTab: 0,
      transitionType: 'none'
    },
    slots: [
      { ...initialSliceSlotState }
    ],
    styles: {
      ...SliceStylesDefaultValues,
      tabAppearance: {
        theme: 'box'
      }
    },
    animations: {}
  })
};
